// Allgemeines Model für Chart-Daten von der API (von API kommt TimeSeriesResponseDto, das dann in ChartDto gemappt wird)

export interface ChartDto {
  title?: string;
  chartType?: 'line' | 'bar' | 'area' | 'combo' | string;

  xAxis: ChartAxisDto;
  yAxis?: ChartAxisDto;

  series: ChartSeriesDto[];
  points: ChartPointDto[];

  meta?: Record<string, unknown>;
}

export interface ChartAxisDto {
  key: string; // z.B. "date"
  label?: string;
  type?: 'date' | 'category' | 'number' | string;
  format?: string; // z.B. "MM.yy"
}

export interface ChartSeriesDto {
  key: string;   // "actual" | "target" | ...
  label: string; // "Ist" | "Ziel" | ...
  axis?: 'y' | 'y2' | string;
  type?: 'line' | 'bar' | 'area' | string; // pro Serie (für combo)
  unit?: string;
}

export interface ChartPointDto {
  x: string | number; // ISO date string oder category oder index
  labels?: Record<string, string | null>; // z.B. { labelDay: "Jan" }
  values: Record<string, number | null>;  // z.B. { actual: 1, target: 2 }
}


export enum DateAggregation {
  Day = 1,
  Week = 2,
  Month = 3,
  Quarter = 4,
  Year = 5,
}

export enum DatePeriod {
  FourteenDays = 1,
  TenWeeks = 2,
  ThirteenMonths = 3,
  EightQuarter = 4,
  AllYears = 5
}

export interface LegendChip {
  label: string;
  color: string;
  datasetIndex: number;
  hidden: boolean;
}